import React from 'react';
import { FDBodyText, FDIcon, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';

const IconWithText = ({ icon, color, text }) => {
  return (
    <FDStack spacing={2}>
      <FDIcon icon={icon} color={color} />
      <FDBodyText value={text} size="md" />
    </FDStack>
  );
};

IconWithText.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  text: PropTypes.string.isRequired,
};

IconWithText.defaultProps = {
  color: 'primary',
};

export default IconWithText;
